import React from "react";
import Banner from "../Banner/Banner";
import Discover from "../Discover/Discover";
import ExploreFeature from "../ExploreFeature/ExploreFeature";
import Featured from "../Featured/Featured";
import FeaturedProduct from "../FeaturedProduct/FeaturedProduct";
import HomeReviews from "../HomeReviews/HomeReviews";
import HomeWatches from "../HomeWatches/HomeWatches";
import Newsletter from "../Newsletter/Newsletter";
import Offer from "../Offer/Offer";

const Home = () => {
  return (
    <main>
      <Banner />
      <Featured />
      <FeaturedProduct/>
      <ExploreFeature />
      <Discover />
      <HomeWatches />
      <Offer />
      
      <HomeReviews />
      <Newsletter />
    </main>
  );
};

export default Home;
